import React from 'react';
import { Link } from 'react-router-dom';
import ROUTES from "../../utils/routes";
import { LazyLoadImage } from 'react-lazy-load-image-component';

const ItemBanner = ({name,idArticulo,imagen}) => {

    return (
        <div className="banner__articles--all--item">
            <div 
                className="item--banner"
            >
                <Link to={ROUTES.DETAILSEMPTY + idArticulo}>
                    <div className="item--banner--image">
                        <LazyLoadImage
                            alt={"itbanner_"+idArticulo}
                            src={imagen}
                        />
                    </div>
                </Link>
                <div className="item--banner--info separator">
                    <hr className="col-8 offset-2"/>
                </div>
                <div className="item--banner--info name">
                    <span className="item--banner--info--name">{name}</span>
                </div>
                <div className="item--banner--info irDetalle">
                    <div className="item--banner--info--detail">
                        <Link to={ROUTES.DETAILSEMPTY + idArticulo}><u>Ver detalles</u></Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ItemBanner;